export const customTableColumns = () => [
  {
    Header: "Código de empleado",
    accessor: "user_code",
  },
  {
    Header: "Nombre",
    accessor: "user_name",
  },
  {
    Header: "Calificación",
    accessor: "nota_total",
  }
];
